// =============================================
// src/pages/Contact.tsx
// =============================================
import React from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  useTheme,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';


const Contact: React.FC = () => {
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    alert('Thank you! Your message has been sent.'); // Replace with real form submission later
  };

  const theme = useTheme();

  return (
    <>

      <Box sx={{ background: theme.palette.background.hero, minHeight: '100vh', color: 'white' }}>        
        <Box
          sx={{
            height: { xs: '45vh', md: '55vh' },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Container maxWidth="lg">
            <Typography variant="h1" sx={{ color: 'text.primary', mb: 2 }}>
              Get In Touch
            </Typography>
            <Typography variant="h4" sx={{ color: 'text.secondary', maxWidth: 600 }}>
              We’d love to hear from you. Let’s plan your next luxury journey.
            </Typography>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{  py: 10 }}>
          <Grid container spacing={8}>
            
            {/* Contact Form */}
            <Grid size={{ xs:12, md:7 }}>
              <Card
                sx={{
                    backdropFilter: 'blur(12px)',
                }}
              >
                <CardContent sx={{ p: { xs: 4, md: 6 } }}>
                  <Typography variant="h4" sx={{ mb: 4 }}>
                    Send us a Message
                  </Typography>

                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid size={{ xs:12, md:6 }}>
                        <TextField
                          fullWidth
                          label="Your Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                        <Grid size={{ xs:12, md:6 }}>
                        <TextField
                          fullWidth
                          label="Email Address"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                        <Grid size={{ xs:12 }}>
                        <TextField
                          fullWidth
                          label="Phone Number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </Grid>
                        <Grid size={{ xs:12 }}>
                        <TextField
                          fullWidth
                          label="Message"
                          name="message"
                          multiline
                          rows={6}
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                        <Grid size={{ xs:12 }}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          fullWidth
                          sx={{ py: 2, fontSize: '1.1rem' }}
                        >
                          Send Message
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Grid>

            {/* Contact Information */}
            <Grid size={{ xs:12, md:5 }}>
              <Card
                sx={{
                  backdropFilter: 'blur(12px)',
                  height: '100%',
                }}
              >
                <CardContent sx={{ p: { xs: 4, md: 6 }, height: '100%' }}>
                  <Typography variant="h5" sx={{ mb: 4 }}>
                    Contact Information
                  </Typography>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Box sx={{ display: 'flex', gap: 3 }}>
                      <PhoneIcon sx={{ fontSize: 28, color: '#3b82f6' }} />
                      <Box>
                        <Typography variant="h6">Call Us</Typography>
                        <Typography color="#cbd5e1">(562) 247-5700</Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 3 }}>
                      <EmailIcon sx={{ fontSize: 28, color: '#3b82f6' }} />
                      <Box>
                        <Typography variant="h6">Email Us</Typography>
                        <Typography color="#cbd5e1">mrpsk2026@gmail.com</Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 3 }}>
                      <LocationOnIcon sx={{ fontSize: 28, color: '#3b82f6' }} />
                      <Box>
                        <Typography variant="h6">Visit Us</Typography>
                        <Typography color="#cbd5e1">
                          123 Luxury Lane<br />
                          LA, CA 93720
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{ mt: 'auto', pt: 6 }}>
                    <Typography variant="body2" color="#cbd5e1">
                      Available 24/7 for your luxury transportation needs.
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

    </>
  );
};

export default Contact;